(function() {

	$(document).ready(() => {
		$('.team-grid__head').on('click', toggleDescription);
	});

	function toggleDescription(event) {
		event.preventDefault();
		
		if (window.innerWidth >= 640) return;

		$(this)
			.parent()
			.toggleClass('open')
			.find('.team-grid__desc')
			.slideToggle();
	}

})();